module.exports = __webpack_public_path__ + "static/media/hero-image-1.a76c7b4c.png";